import React from "react";
import { Navigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";

export default function ProtectedRoute({ children, adminOnly = false }) {
  const { user, checked } = useAuth();
  if (!checked) {
    return (
      <div className="min-h-[60vh] flex items-center justify-center text-slate-500">
        <div className="text-sm tracking-overline uppercase">Loading…</div>
      </div>
    );
  }
  if (!user || !user.email) return <Navigate to="/login" replace />;
  if (adminOnly && user.role !== "admin") return <Navigate to="/" replace />;
  return children;
}
